import {Component, ElementRef, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NbDialogService, NbToastrService} from '@nebular/theme';
//import {NgxSpinnerService} from 'ngx-spinner';
import {ActivatedRoute, Router, Params} from '@angular/router';
import {LocalDataSource} from 'ng2-smart-table';
import {MainService} from '../../../services/main.service';
import * as S3 from "aws-sdk/clients/s3";

@Component({
  selector: 'app-edit-usuarios',
  templateUrl: './edit-usuarios.component.html',
  styleUrls: ['./edit-usuarios.component.scss']
})
export class EditUsuariosComponent implements OnInit {
  bucket: S3 = new S3({
    accessKeyId: "AKIAUT7IXVID4CI4XZVD",
    secretAccessKey: "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",
    region: "us-east-1"
  });
  img: any;
  frmUsuario: FormGroup;
  submitted = false;
  changeImg= false;
  imagen: any = [""];
  loading = false;
  UsuarioCC: any;
  listaIMG: any[] = [];
  ListaFotos: any = [""];
  usuario = {
    cc:'',
    usuario:'',
    nombres: '',
    apellidos: '',
    email: '',
    rol: '',
    telefono: '',
    grupo: '',
    direccion: '',
    img: '',
  };
  listaGrupos: any[];

  constructor(private toastrService: NbToastrService,
    public router: Router,
    private dialogService: NbDialogService,
    private rutaActiva: ActivatedRoute,
    public mainService: MainService,
    public fb: FormBuilder) { 
      this.UsuarioCC = this.rutaActiva.snapshot.params.id;
      this.getUsuario(this.UsuarioCC);
      this.getGrupos();
      this.frmUsuario = this.fb.group({
        cc:[''],
        usuario:[''],
        nombres: [''],
        apellidos: [''],
        email: [''],
        telefono: [''],
        rol: [''],
        grupo: [''],
        direccion: ['']
    });
    }

  ngOnInit() {
  }
  getUsuario(id) {
    this.mainService.get('tadmUsuario/'+id).subscribe(result => {
      if (result) {
        console.log(result);
        this.usuario.cc = this.UsuarioCC,
        this.usuario.usuario= result.usualogin;
        this.usuario.nombres= result.usua_nombres;
        this.usuario.apellidos= result.usua_apellidos;
        this.usuario.email= result.usua_email;
        this.usuario.telefono= result.usua_telefonos;
        this.usuario.rol= result.perfil;
        this.usuario.grupo= result.id_empresa;
        this.usuario.direccion= result.usua_direccion;
        this.usuario.img= result.id_imagen_mongo_usuario;
        //let img = { src: result.id_imagen_mongo_usuario };
        //this.listaIMG.push(img);
        //console.log(this.listaIMG)
      } else {
        console.log("Error al insertar en Sql");
      }
    })
}
getGrupos(){
  this.mainService.get('tadmSelectType/Grupo').subscribe(value => {
    console.log(value);
    this.listaGrupos = value;
  })
}
DeleteIMG() {
  this.usuario.img = '';
}
get valoresCrear() {
  return this.frmUsuario.controls;
}
readUrl(event: any) {
  //this.modImg = true;
  this.changeImg = true;
  this.imagen = event.target.files[0];
  console.log(this.imagen);
  if (event.target.files && event.target.files[0]) {
    var reader = new FileReader();
    reader.onload = (event: ProgressEvent) => {
      let img = (<FileReader>event.target).result ;
      console.log(img)
      this.listaIMG.push(img);
      this.usuario.img= this.listaIMG[0];
      //this.listaIMG[0].src = (<FileReader> event.target).result;
    };
    reader.readAsDataURL(event.target.files[0]);
  }
}
onGoTo() {
  this.router.navigate(["dashboard/usuarios"]);
}
makeid(length) {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}
save() {
  this.loading = true;
  if(this.changeImg === true){
    this.listaIMG = [];
    var params = {
      Bucket: "printech-resources",
      ACL: "public-read",
      Key: this.makeid(8) + this.imagen.name.trim(),
      ContentType: this.imagen.type,
      Body: this.imagen
    };
    var options = {
      // Part Size of 10mb
      partSize: 10 * 1024 * 1024,
      queueSize: 1,
      // Give the owner of the bucket full control
      ACL: "public-read"
    };
    const self = this;
    var uploader = this.bucket.upload(params, options, function(err, data) {
      if (err) {
        console.log("PERDIDAS");
        this.loadingImage = false;
      }
      console.log("SUCCESS");
      console.log(data);
      self.ListaFotos[0] = data.Location.toString();
      console.log(self.ListaFotos);
      self.editUsuario();
    });
    uploader.on("httpUploadProgress", function(event) {
      console.log("UPDATE");
      console.log(event);
      var total = (event.loaded * 100) / event.total;
      console.log(total);
    });
    return;
  }else{
    this.editUsuario();
  }
 
}
editUsuario() {
  this.submitted = true;
  if (this.frmUsuario.invalid) {
      return false;
  }
  //this.spinner.show();
  let usu = this.frmUsuario.value;
  console.log(usu);
  if(this.changeImg === true){
     this.img = this.ListaFotos[0];
  }else{
    this.img = usu.id_imagen_mongo_usuario;
  }
  let insert = {
      usua_identifica: usu.cc,
      usualogin: usu.usuario,
      usua_nombres:usu.nombres,
      usua_apellidos:usu.apellidos,
      usua_email:usu.email,
      usua_telefonos:usu.telefono,
      perfil:usu.rol,
      id_empresa:usu.grupo,
      usua_direccion: usu.direccion,
      id_imagen_mongo_usuario: this.img,
  }
  console.log(insert);
  this.mainService.put('tadmUsuario/'+ this.UsuarioCC, insert).subscribe(result => {
      console.log(result);
      if (result) {
          console.log('Se ha insertado');
          this.submitted = false;
          this.loading = false;
          this.changeImg = false;
          this.showToast('top-right', 'success', 'Success!', 'Se ha creado con exito');
          this.getUsuario(this.UsuarioCC);
          return true;
      } else {
          console.log('Error');
          this.submitted = false;
          this.loading = false;
          this.changeImg = false;
          this.showToast('top-right', 'warning', 'Error!', 'Error!');
          this.getUsuario(this.UsuarioCC);
          return false;
      }
  });
}
showToast(position, status, titulo, mensaje) {
  this.toastrService.show(mensaje, titulo, { position, status });
}
}
